import React, { FC } from 'react'
import { ConfirmationModal } from 'transfix-ui'
import { CarrierComplianceText } from './rate-confirmation/CarrierComplianceText'

interface ICarrierComplianceModalProps {
  onClose: () => void
  isOpen: boolean
  onSubmit: () => void
}

export const CarrierComplianceModal: FC<ICarrierComplianceModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
}) => {
  const placeBidHandler = () => {
    onSubmit()
    onClose()
  }

  return (
    <ConfirmationModal
      title='Compliance check required'
      size={3}
      open={isOpen}
      actions={[
        {
          label: 'Cancel',
          type: 'dismiss',
          action: onClose,
        },
        {
          label: 'Submit a Bid to Continue',
          type: 'confirm',
          action: placeBidHandler,
        },
      ]}
      onClose={onClose}>
      <CarrierComplianceText />
    </ConfirmationModal>
  )
}
